
import { api } from "constants/RotasAPI";
import { useMutation } from "react-query";
import { http } from "shared/util/http";
import { ValidarDespesaDuplicadaNumeroDocumentoFornecedorRequest } from "types/request/contasPagar/ValidarDespesaDuplicadaNumeroDocumentoFornecedorRequest";

export const usePostValidarDespesaDuplicadaNumeroDocumentoFornecedor = () => {
  const mutationFn = async (
    requestData: ValidarDespesaDuplicadaNumeroDocumentoFornecedorRequest
  ): Promise<void> => {
    await http.post(
      api.contasPagar.postValidarDespesaDuplicadaNumeroDocumentoFornecedorContasPagar,
      requestData
    );
  };
  return useMutation(mutationFn);
};